const SEGMENT_TEXT = {
  reset: 'Sıfırlama',
  friction: 'Sürtünme',
  stable: 'Dengeli',
  strong: 'Güçlü',
  smoke: 'Deneme'
};

const VARIANT_TEXT = {
  primary: 'Ana Mesaj',
  secondary: 'İkincil Mesaj',
  reassurance: 'Destek Mesajı'
};

function toTitleCase(value) {
  const text = String(value || '').trim();
  if (!text) return 'Tanımsız';
  return text.charAt(0).toLocaleUpperCase('tr-TR') + text.slice(1).toLocaleLowerCase('tr-TR');
}

export function parseTemplateKey(templateKey) {
  const raw = String(templateKey || '').trim();
  if (!raw) {
    return {
      scenarioKey: '',
      scenarioLabel: 'Tanımsız Senaryo',
      variantKey: '',
      variantLabel: 'Tanımsız Mesaj Tipi',
      technicalKey: ''
    };
  }

  const parts = raw
    .split(/[._]/g)
    .map((part) => String(part || '').trim().toLowerCase())
    .filter(Boolean);

  const variantKey = parts.find((part) => Object.prototype.hasOwnProperty.call(VARIANT_TEXT, part)) || '';
  const scenarioKey = parts.find((part) => Object.prototype.hasOwnProperty.call(SEGMENT_TEXT, part)) || '';

  const scenarioLabel = scenarioKey
    ? SEGMENT_TEXT[scenarioKey]
    : (parts.length > 1 ? toTitleCase(parts[1]) : toTitleCase(parts[0]));

  const variantLabel = variantKey ? VARIANT_TEXT[variantKey] : 'Genel Mesaj';

  return {
    scenarioKey,
    scenarioLabel,
    variantKey,
    variantLabel,
    technicalKey: raw
  };
}

export function readableTemplateLabel(templateKey, version) {
  const parsed = parseTemplateKey(templateKey);
  const versionLabel = Number(version) > 0 ? `v${Number(version)}` : null;
  const title = versionLabel
    ? `${parsed.scenarioLabel} · ${parsed.variantLabel} · ${versionLabel}`
    : `${parsed.scenarioLabel} · ${parsed.variantLabel}`;
  return {
    title,
    technicalKey: parsed.technicalKey
  };
}

